import { createSlice } from "@reduxjs/toolkit";
import {
  getConfiguracionAplicacionPlantelThunk,
  updateConfiguracionAplicacionPlantelThunk,
} from "./aplicacionConfigPlantel.thunks";

const initialState = {
  config: null,
  loading: false,
  saving: false,
  error: null,
};

const aplicacionConfigPlantelSlice = createSlice({
  name: "aplicacionConfigPlantel",
  initialState,
  reducers: {
    clearAplicacionConfigError: (state) => {
      state.error = null;
    },
    resetAplicacionConfigPlantel: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConfiguracionAplicacionPlantelThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getConfiguracionAplicacionPlantelThunk.fulfilled,
        (state, action) => {
          state.loading = false;
          state.config = action.payload;
        },
      )
      .addCase(
        getConfiguracionAplicacionPlantelThunk.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      )
      .addCase(updateConfiguracionAplicacionPlantelThunk.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(
        updateConfiguracionAplicacionPlantelThunk.fulfilled,
        (state, action) => {
          state.saving = false;
          state.config = action.payload;
        },
      )
      .addCase(
        updateConfiguracionAplicacionPlantelThunk.rejected,
        (state, action) => {
          state.saving = false;
          state.error = action.payload;
        },
      );
  },
});

export const { clearAplicacionConfigError, resetAplicacionConfigPlantel } =
  aplicacionConfigPlantelSlice.actions;

export default aplicacionConfigPlantelSlice.reducer;
